// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"7702242e","213":"b0f24f1b","239":"7849374c","732":"9d79faa5"}[chunkId] + ".chunk.js";
};